import React from 'react';
import { motion } from 'framer-motion';
import { PLANET_CONFIG, ASPECT_CONFIG, longitudeToPosition } from './clockUtils';

const AspectLines = ({ 
  aspects, positions,
  innerZoneMax = 65, edgeZoneRadius = 135, outerZoneMin = 160, outerZoneMax = 228
}) => {
  if (!aspects || !positions) return null;

  const getHandLength = (planet) => {
    const config = PLANET_CONFIG[planet] || { zone: 'outer', zonePosition: 0.5 };
    return config.zone === 'inner' 
      ? 20 + config.zonePosition * (innerZoneMax - 20)
      : config.zone === 'edge' 
        ? edgeZoneRadius 
        : outerZoneMin + config.zonePosition * (outerZoneMax - outerZoneMin);
  };

  const getPlanetPosition = (planet) => {
    const pos = positions[planet];
    if (!pos) return null;
    return longitudeToPosition(pos.longitude, getHandLength(planet));
  };

  return (
    <motion.g initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.8, duration: 0.5 }} data-testid="aspect-lines">
      {aspects.map((aspect, index) => {
        const config = ASPECT_CONFIG[aspect.aspect];
        if (!config) return null;
        const pos1 = getPlanetPosition(aspect.planet1);
        const pos2 = getPlanetPosition(aspect.planet2);
        if (!pos1 || !pos2) return null;

        return (
          <line key={`${aspect.planet1}-${aspect.planet2}-${aspect.aspect}-${index}`}
            x1={pos1.x} y1={pos1.y} x2={pos2.x} y2={pos2.y}
            stroke={config.color} strokeWidth={config.width} strokeDasharray={config.dash}
            opacity={config.opacity} strokeLinecap="round"
          />
        );
      })}
    </motion.g>
  );
};

export default AspectLines;
